import classnames from 'classnames';
import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { emitTravelersClickGAEvent, emitTravelersSelectGAEvent } from 'utils/ga-event-helpers';
import { openInput } from '../../../../actions/baseActions';
import { setCountAdults, setCountChildren } from '../../../../actions/flightActions';
import FadeTransition from '../../Common/FadeTransition';
import CounterItem from '../../Flight/Passengers/CounterItem';

type PassengerCounterProps = {
	openedInput?: string;
	name: string;
	placeholder: string;
	countAdults: number;
	countChildren: number;
	openInput: (name: string | null) => void;
	setCountAdults: (count: number) => void;
	setCountChildren: (count: number) => void;
};
type PassengerCounterState = {
	in: boolean;
	adults: number;
	children: number;
};

const PassengerCounter: FC<PassengerCounterProps> = (props) => {
	const { t } = useTranslation();
	const [state, setState] = useState<PassengerCounterState>({
		in: false,
		adults: 1,
		children: 0,
	});

	const getSelected = () => {
		const { countAdults, countChildren } = props;
		if (countAdults && countChildren) {
			return t('keywords.passengersWithCount', { count: countAdults + countChildren });
		}
		return t('keywords.adultsWithCount', { count: countAdults });
	};

	const showItemsList = () => {
		if (props.openedInput !== props.name) {
			emitTravelersClickGAEvent();
		}
		props.openInput(props.openedInput === props.name ? null : props.name);
		setState({ ...state, in: !state.in });
	};

	useEffect(() => {
		if (state.in && props.openedInput !== props.name) {
			emitTravelersSelectGAEvent({
				adults: countAdults,
				children: countChildren,
				total: countAdults + countChildren,
			});
			setState({ ...state, in: false });
		}
	}, [props.openedInput]);

	const handleAdultCountChange = (count: number) => {
		props.setCountAdults(count);
	};

	const handleChildCountChange = (count: number) => {
		props.setCountChildren(count);
	};

	const { countAdults, countChildren } = props;
	return (
		<div
			className={classnames('basic-drop-down passenger-counter', {
				'open-input': props.openedInput === props.name,
			})}
		>
			<div className='dropdown-input' onClick={showItemsList}>
				<span className="d-name">{getSelected()}</span>
				<span className="d-icon">
					<i className="icon-arrow" />
				</span>
			</div>
			<FadeTransition timeout={1} in={props.openedInput === props.name}>
				<div className="body">
					<CounterItem onCountChange={handleAdultCountChange} count={countAdults} name={t('keywords.adults')} />
					<CounterItem onCountChange={handleChildCountChange} count={countChildren} name={t('keywords.children')} />
				</div>
			</FadeTransition>
		</div>
	);
};

// @ts-ignore
const mapStateToProps = (state) => ({
	openedInput: state.base.openedInput,
	countAdults: state.flight.countAdults,
	countChildren: state.flight.countChildren,
});

export default connect(mapStateToProps, { openInput, setCountChildren, setCountAdults })(PassengerCounter);
